<div *ngIf="allDataTypes">
  <div *ngIf="!isQuestionSettingsChecked">
    <form [formGroup]="addQuestionForm">
      <div class="flex flex-row justify-start items-center" *ngIf="!addNewSectionInProgress">
        <mat-form-field appearance="outline" class="m-r-10 full-grow-no-shrink-no-basis">
          <mat-label>Section</mat-label>
          <mat-select placeholder="Select a section"
                      (selectionChange)="onSectionChange($event)"
                      formControlName="questionSection">
            <mat-option *ngFor="let section of sections" [value]="section?.sectionId">
              {{section?.header}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-button class="common-button m-b-20" (click)="showAddSection()">Add Section
        </button>
      </div>
      <div *ngIf="addNewSectionInProgress" class="m-b-20">
        <particle-inplace-input
          text=""
          placeHolder="Section name"
          (valueChanged)="addSection($event)"
          (cancelled)='resetEditing()'
        ></particle-inplace-input>
      </div>

      <div>
        <mat-form-field appearance="outline" class="m-r-10 flex-0-0-100">
          <mat-label>Field Name</mat-label>
          <input matInput formControlName="questionHeader" type="text" id="question-header" placeholder="Field Name">
          <mat-error *ngIf="addQuestionForm.controls['questionHeader'].hasError('required')">
            Field Name is required!
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline" class="flex-1-1-100">
          <mat-label>Field Details</mat-label>
          <input matInput formControlName="questionInstruction" type="text" id="question-instruction"
                 placeholder="Field Details">
          <mat-hint>Use the Field Details to provide details/instructions on how to populate this field. This
            information will be displayed should this field be included as part of a Data Survey.
          </mat-hint>
          <mat-error *ngIf="addQuestionForm.controls['questionInstruction'].hasError('required')">
            Instruction is required!
          </mat-error>
        </mat-form-field>
      </div>
      <div *ngIf="selectedDataType">
        <mat-form-field appearance="outline" class="m-r-10 flex-0-0-50">
          <mat-label>Field Type</mat-label>
          <mat-select placeholder="Select a field Type"
                      formControlName="questionDataType">
            <mat-option *ngFor="let dataType of allDataTypes" [value]="dataType?.dataTypeConfigKey"
                        (onSelectionChange)="onSelectionChange($event,dataType)">
              {{dataType?.header}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-button class="link-button" *ngIf="fieldSettings" (click)=navigateToQuestionSettings()>
          <i class="far fa-cog"></i><span>Settings</span>
        </button>
      </div>
      <div class="m-b-20">
        <mat-slide-toggle formControlName="isRequired">Required</mat-slide-toggle>
      </div>
    </form>
  </div>

  <div class="flex flex-col" *ngIf="isQuestionSettingsChecked" style="margin-top: -20px">
    <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
      <div class="full-grow-no-shrink-no-basis">
        <button class="mr-sm-16 mat-icon-button back-btn" mat-icon-button tabindex="0"
                (click)="onCloseQuestionSettings()">
          <mat-icon class="mat-icon ng-tns-c39-36 material-icons" role="img"
                    aria-hidden="true">arrow_back
          </mat-icon>
        </button>
      </div>
    </div>

    <div class="options-container">
      <ng-template #dynamicComponent></ng-template>
    </div>
  </div>

</div>
